import React from "react";
import RespondentTerminalPage from "../components/ending/RespondentTerminalPage";

const OverQuotaV2 = () => {
  return (
    <RespondentTerminalPage
      variant="overquota"
      message="This survey has reached its required number of responses. Thank you for your interest."
    />
  );
};

export default OverQuotaV2;
